const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_embed/c/$embedSpaceSlug/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

// Mirrors the search schema on
// "/_protected/_dynamicLayout/c/$spaceSlug" so Events filters (status,
// pastEvents, sort, topics) and the iframe flag work inside the embed too.
const embedSpaceSlugSearchSchema = z.object({
  pastEvents: z.boolean().optional().catch(undefined),
  status: z.string().optional().catch(undefined),
  topics: z.union([z.string(), z.number()]).optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
  iframe: z.boolean().optional().catch(undefined)
});
export const Route = createFileRoute("/_protected/_embed/c/$embedSpaceSlug")({
  validateSearch: embedSpaceSlugSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});